/**
 * Subscribe to Voice Stack while the Hottie sheet is open.
 *
 * `idle` is sheet-open with no audio (level 0) → resting, intensity 1.
 * A closed sheet does not listen: the Orb follows resting / interested / fan.
 * The dock/rail Orb is the visual — no second Orb, no fifth state.
 */
import { useEffect, useState } from 'react';
import {
  HOTTIE_VOICE_EVENT,
  hottieVoiceToOrb,
  isHottieVoicePhase,
  type HottieOrbVisual,
  type HottieVoiceDetail,
  type HottieVoicePhase,
} from './hottie';

export function useHottieVoice(sheetOpen: boolean): HottieOrbVisual | null {
  const [phase, setPhase] = useState<HottieVoicePhase>('idle');
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!sheetOpen) {
      setPhase('idle');
      setLevel(0);
      return;
    }

    const onVoice = (event: Event) => {
      const detail = (event as CustomEvent<HottieVoiceDetail>).detail;
      if (!detail || !isHottieVoicePhase(detail.phase)) return;
      setPhase(detail.phase);
      setLevel(typeof detail.level === 'number' ? detail.level : 0);
    };

    window.addEventListener(HOTTIE_VOICE_EVENT, onVoice);
    return () => window.removeEventListener(HOTTIE_VOICE_EVENT, onVoice);
  }, [sheetOpen]);

  if (!sheetOpen) return null;
  return hottieVoiceToOrb(phase, level);
}
